<dialog-draggable-header>
  Add Build Design Weight
</dialog-draggable-header>

<form [formGroup]="form" class="row">
  <mat-form-field *ngFor="let column of fields" class="col-3">
    <input [formControlName]="column.field" matInput [placeholder]="column.name" pattern="^0{1}\.\d{1,15}$" />
  </mat-form-field>
</form>

<div class="d-flex justify-content-end">
  <button class="mx-2" mat-raised-button color="primary" (click)="saveBuildDesignWeight()"
    [disabled]="form.invalid">Save</button>
  <button mat-raised-button mat-dialog-close>Close</button>
</div>